export default {
  FROM_PACKAGE: 0,
  INVOICE: 1,
};